import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TermsOfService from './components/TermsOfService';
import PrivacyPolicy from './components/PrivacyPolicy';
ReactDOM.createRoot(document.getElementById('root')!).render(<React.StrictMode data-id="element-557">
    <Router data-id="element-558">
      <Routes data-id="element-559">
        <Route path="/" element={<App data-id="element-561" />} data-id="element-560" />
        <Route path="/terms" element={<TermsOfService language="en" data-id="element-563" />} data-id="element-562" />
        <Route path="/privacy" element={<PrivacyPolicy language="en" data-id="element-565" />} data-id="element-564" />
        <Route path="/terms-ar" element={<TermsOfService language="ar" data-id="element-567" />} data-id="element-566" />
        <Route path="/privacy-ar" element={<PrivacyPolicy language="ar" data-id="element-569" />} data-id="element-568" />
      </Routes>
    </Router>
  </React.StrictMode>);